// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Schedule extends APIResource {
    /**
     * Schedule a message to be sent by the agent at a specified time or on a recurring
     * basis.
     */
    create(agentID, body, options) {
        return this._client.post(path `/v1/agents/${agentID}/schedule`, { body, ...options });
    }
    /**
     * Retrieve a scheduled message by its ID for a specific agent.
     */
    retrieve(scheduledMessageID, params, options) {
        const { agent_id } = params;
        return this._client.get(path `/v1/agents/${agent_id}/schedule/${scheduledMessageID}`, options);
    }
    /**
     * List all scheduled messages for a specific agent.
     */
    list(agentID, query = {}, options) {
        return this._client.get(path `/v1/agents/${agentID}/schedule`, { query, ...options });
    }
    /**
     * Delete a scheduled message by its ID for a specific agent.
     */
    delete(scheduledMessageID, params, options) {
        const { agent_id, ...body } = params;
        return this._client.delete(path `/v1/agents/${agent_id}/schedule/${scheduledMessageID}`, {
            body,
            ...options,
        });
    }
}
//# sourceMappingURL=schedule.mjs.map